import { CommonModule } from "@angular/common";
import { inject, NgModule, provideAppInitializer } from "@angular/core";
import { AdaptEditorViewModule } from "@common/ux/html-editor/editor-view.module";
import { HtmlEditorService } from "@common/ux/html-editor/html-editor.service";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptMenuModule } from "@common/ux/menu/menu.module";
import { DxListModule, DxPopoverModule } from "devextreme-angular";
import { AdaptDirectorySharedModule } from "../directory-shared/directory-shared.module";
import { CurrentWatchersViewComponent } from "./current-watchers-view/current-watchers-view.component";
import { DisplayMentionPersonComponent } from "./display-mention-person/display-mention-person.component";
import { attachMentionPersonPopover } from "./mention-person-popover";
import { SelectWatcherListComponent } from "./select-watcher-list/select-watcher-list.component";


@NgModule({
    declarations: [
        SelectWatcherListComponent,
        CurrentWatchersViewComponent,
        DisplayMentionPersonComponent,
    ],
    imports: [
        CommonModule,
        DxListModule,
        DxPopoverModule,
        AdaptEditorViewModule,
        AdaptMenuModule,
        AdaptLoadingSpinnerModule,
        AdaptDirectorySharedModule,
    ],
    exports: [
        SelectWatcherListComponent,
        CurrentWatchersViewComponent,
    ],
    providers: [
        provideAppInitializer(() => inject(HtmlEditorService).registerEditorViewCallback(attachMentionPersonPopover)),
    ],
})
export class AdaptWatcherModule { }
